<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>
    lblCustomerRecipient
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="OnClose()">
    <span aria-hidden="true">
      ×
    </span>
  </button>
</div>
<div class="modal-body min-h25p">
  <div class="popup-vcenter">
    <div class="form-row d-flex">
      <div class="pad15 mb15">
        <div *ngFor="let myRecipient of myRecipientList; let in=index;let last=last">
          <form name="form{{in}}" #f="ngForm">
            <div class="row">
              <div class="col-2 af-form-group">
                <label translate>lblRole</label>
                <div class="lbl-info">
                  <select class="form-control" [(ngModel)]="myRecipient.userTypeId" name="userTypeName{{in}}"
                    (change)="roleNameSelected($event.target.selectedIndex)" id="Add-UserType{{in}}" #roleName="ngModel"
                    [class.in-invalid]="roleName.isvalid && roleName.touched" required>
                    <option selected disabled [ngValue]="0" translate>lblSelect</option>
                    <option *ngFor="let userType of dealerUserTypeList" [(ngValue)]="userType.userTypeId">
                      {{userType.name}}
                    </option>
                  </select>
                  <div *ngIf="roleName.touched && roleName.errors?.required" class="help-block text-danger">
                    <span translate>lblPleaseSelectCompetence</span>
                  </div>
                </div>
              </div>
              <div class="col-4 af-form-group">
                <label translate>lblMobile</label>
                <div class="lbl-info">
                  <ngx-intl-tel-input name="mobile{{in}}" [cssClass]="{'form-control': true, 'is-invalid': (mobile.touched || mobile.dirty) && mobile.errors}"
                  [selectedCountryISO]="selectedCountryISO[in]" [maxLength]="15" [phoneValidation]="true" 
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false" 
                  [(ngModel)]="myRecipient.mobile" (countryChange)="onCountryChange($event, in)" #mobile="ngModel"
                  ></ngx-intl-tel-input>
                </div>
                <div *ngIf="(mobile.touched || mobile.dirty) && mobile.errors">
                  <div *ngIf="mobile.errors.pattern" class="help-block mt-1 text-danger" translate>
                    lblEnterValidMobile
                  </div>
                </div>
              </div>
              <div class="col-2 af-form-group">
                <label translate>lblEmail</label>
                <div class="lbl-info">
                  <input type="text" maxlength="64" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    [ngClass]="{'is-invalid': (email.touched || email.dirty) && email.errors}" class="form-control"
                    name="email{{in}}" [(ngModel)]="myRecipient.email" #email="ngModel">
                </div>
                <div *ngIf="(email.touched || email.dirty) && email.errors">
                  <div *ngIf="email.errors.pattern" class="help-block mt-1 text-danger" translate>
                    lblEnterValidEmail
                  </div>
                </div>
              </div>
              <div class="col-2 af-form-group">
                <label translate>lblUserName</label>
                <div class="lbl-info">
                  <input type="text" class="form-control" name="tag{{in}}" [(ngModel)]="myRecipient.userName">
                </div>
              </div>
              <div class="col-2 af-form-group">
                <div class="mt-4">
                  <button type="submit" class="btn btn-primary mr-sm-2 mt-1"
                    [disabled]="myRecipient.userTypeId==0 || !myRecipient.mobile || email.errors || mobile.errors"
                    #addButton (click)="AddDealerNotification(myRecipient,in)" *ngIf="last" translate>
                    <em class="fas fa-plus fa-lg"></em>
                  </button>
                  <button type="submit" class="btn btn-light mr-sm-2 mt-1" (click)="RemoveDealerNotification(in)">
                    <em class="far fa-times-circle fa-lg"></em>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary mr-sm-2" (click)="AddRecipient()" translate>
    lblSave
  </button>
  <button type="button" class="btn btn-secondary mr-sm-2" (click)="ResetRecipient()" translate>
    lblReset
  </button>
</div>